module.exports = __webpack_public_path__ + "static/media/soccer_icon-01.615672ce.png";